import { upload } from './upload.js';
import { orderStatus, shipmentMethods, ShipmentMethod } from './order.js';

export const consts = { upload, shipmentMethods, orderStatus };

export type { ShipmentMethod };
